import React from "react";
import { Link } from "react-router-dom";
import { OpticDetail } from "@/api/qpcr";
import { Time } from "@/components/common/Time";

export function OpticHeader({ optic }: { optic: OpticDetail }) {
  return (
    <header className="space-y-sm">
      <Link to={`/devices/${optic.device_id}/qpcr`} className="text-textLight text-sm hover:underline">
        ← Back to device runs
      </Link>
      <h1 className="text-xl font-semibold">qPCR run</h1>
      <dl className="grid grid-cols-2 gap-x-lg gap-y-xs text-sm">
        <dt className="text-textLight">Run id</dt>
        <dd className="font-mono text-xs">{optic.id}</dd>
        <dt className="text-textLight">Device ref</dt>
        <dd className="font-mono text-xs">{optic.ref ?? "—"}</dd>
        <dt className="text-textLight">Received</dt>
        <dd><Time iso={optic.received_at} /></dd>
        <dt className="text-textLight">Captured</dt>
        <dd><Time iso={optic.captured_at} /></dd>
        <dt className="text-textLight">Debug</dt>
        <dd>{optic.debug ? "yes" : "no"}</dd>
        <dt className="text-textLight">Hidden</dt>
        <dd>{optic.hidden ? "yes" : "no"}</dd>
      </dl>
    </header>
  );
}
